import React from 'react';
import './AllEvents.css';
import eventsData from '../data/events.json';
import { useContent } from '../contexts/ContentContext';

type EventItem = {
  id: string;
  title: string;
  description: string;
  location?: string;
  attendees?: number | string;
};

const AllEvents = () => {
  const { getSection } = useContent();
  const data = getSection<typeof eventsData>('events', eventsData);
  const events = data.events as EventItem[];

  return (
    <div className="all-events-page">
    <div className="page-container">
        <div className="page-header">
          <h1 className="page-title">All Events</h1>
          <p className="page-subtitle">
            Complete timeline of all ASIMO Technical Club events and activities
          </p>
        </div>

        <div className="events-grid">
          {events.map((event) => (
            <div key={event.id} className="event-item">
              <div className="event-content">
                <h3 className="event-title">{event.title}</h3>
                <div className="event-meta">
                  <span className="event-location">📍 {event.location || 'GEC Samastipur'}</span>
                  <span className="event-attendees">👥 {event.attendees || 'Open'} attendees</span>
                </div>
                <p className="event-description">{event.description}</p>
                
                <div className="event-actions">
                  <button className="btn-learn">Learn More</button>
                </div>
              </div>
            </div>
          ))}
        </div>

        <div className="back-to-home">
          <button 
            className="btn-back"
            onClick={() => window.history.back()}
          >
            ← Back to Home
          </button>
        </div>
      </div>
      </div>
  );
};

export default AllEvents;